export const DateUtcDifferenceInSeconds = (date?: Date | string) => {
    if (!date) return;
    const dateAsDate = typeof date == "string" ? new Date(date) : date;
    return (new Date().getTime() - dateAsDate.getTime()) / 1000;
};
